import gql from 'graphql-tag'


export const SAVE_RECOMMENT = gql`
    mutation saveReComment(
        $reCommentId:String!
        $videoId:String!
        $makerChannelId:String!
        $makerChannelDisplayName:String!
        $makerChannelProfileImageUrl:String!
        $makerUpdatedAt:Date!
        $makerPublishedAt:Date!
        $textOriginal:String!
        $likeCount:Int!
        $topCommentId:String!
    ){
        saveReComment(
            reCommentId: $reCommentId
            videoId: $videoId
            makerChannelId: $makerChannelId
            makerChannelDisplayName: $makerChannelDisplayName
            makerChannelProfileImageUrl: $makerChannelProfileImageUrl
            makerUpdatedAt: $makerUpdatedAt
            makerPublishedAt: $makerPublishedAt
            textOriginal: $textOriginal
            likeCount: $likeCount
            topCommentId: $topCommentId
        ){
            reCommentId
            videoId
            makerChannelId
            makerChannelDisplayName
            makerChannelProfileImageUrl
            makerUpdatedAt
            makerPublishedAt
            textOriginal
            likeCount
        }
    }
`